<script lang="ts" setup>
const props = withDefaults(
    defineProps<{
        items: Record<string, any>[];
        by: string;
        inviting: boolean;
        open: boolean;
        object: [string, string];
    }>(),
    {
        object: () => ["item", "items"],
    },
);

const emit = defineEmits<{
    (e: "invite"): void;
    (e: "update:open", v: boolean): void;
}>();

const isOpen = computed({
    get: () => !!(props.open && props.items?.length),
    set: ($event) => emit("update:open", $event),
});
</script>

<template>
    <UModal v-model="isOpen">
        <UCard
            :ui="{
                ring: '',
                divide: 'divide-y divide-gray-100 dark:divide-gray-800',
            }"
        >
            <template #header>
                <div class="flex items-center justify-between">
                    <h3
                        class="text-base font-medium font-display leading-6 text-gray-900 dark:text-white"
                    >
                        <template v-if="items.length > 1">
                            Are you sure you want to invite the following
                            {{ object[1] }}?
                        </template>
                        <template v-else>
                            Are you sure you want to invite this
                            {{ object[0] }}?
                        </template>
                    </h3>
                    <UButton
                        color="gray"
                        variant="ghost"
                        icon="i-heroicons-x-mark-20-solid"
                        class="-my-1"
                        @click="emit('update:open', false)"
                    />
                </div>
            </template>
            <div class="prose prose-sm">
                <ul>
                    <li v-for="item in items" :key="item[by]">
                        {{ item[by] }}
                    </li>
                </ul>
            </div>
            <template #footer>
                <div class="flex items-center gap-3 justify-end">
                    <UButton
                        :disabled="inviting"
                        color="white"
                        label="Cancel"
                        @click="emit('update:open', false)"
                    />
                    <UButton
                        :disabled="inviting"
                        :loading="inviting"
                        color="primary"
                        label="Invite"
                        @click="emit('invite')"
                    />
                </div>
            </template>
        </UCard>
    </UModal>
</template>
